import * as logic from './logic';
export var filterProductListByService = function (list, service) {
    var filteredList = list.filter(function (selectedFinancialProduct) { return logic.KERequired.getKERequiredByService(selectedFinancialProduct, service) !== false; });
    return filteredList;
};
